export const ONE_MEGABYTE = 1048576;

/**
 * Cutoff date for allowing redaction removal.
 * Only documents uploaded after this date can have their redactions removed.
 * This is a safety net to protect legacy documents from accidental redaction removal.
 */
export const REDACTION_REMOVAL_CUTOFF_DATE = new Date(
  '2026-01-03T00:00:00.000Z',
);

/**
 * Checks if redaction removal is allowed for a given resource.
 * @param resourceCreatedAt - The creation date of the resource (ISO string or Date)
 * @returns true if redaction removal is allowed, false otherwise
 */
export function isRedactionRemovalAllowed(
  resourceCreatedAt: string | Date | undefined | null,
): boolean {
  if (!resourceCreatedAt) return false;
  const createdAt = new Date(resourceCreatedAt);
  return createdAt >= REDACTION_REMOVAL_CUTOFF_DATE;
}
